export const TypesAvariasOEA = {
    AVARIAS_OEA: "AVARIAS_OEA",
    ADD_AVARIAS_OEA: "ADD_AVARIAS_OEA",
    REMOVE_AVARIAS_OEA: "REMOVE_AVARIAS_OEA",
    SEM_INCIDENCIA_CHECKED: "SEM_INCIDENCIA_CHECKED",
    AVARIA_OEA_LOCAL_CHECKED: "AVARIA_OEA_LOCAL_CHECKED",
    AVARIA_OEA_TIPO_CHECKED: "AVARIA_OEA_TIPO_CHECKED",
    AVARIA_OEA_REMOVER_CHECKED: "AVARIA_OEA_REMOVER_CHECKED",
    RESET_OEA: "RESET_OEA"
}

const INITIAL = {
    $id: 0,
    Sucesso: false,
    Mensagem: "",
    TiposAvaria: [],
    LocaisAvaria: [],
    TiposAvariaPadrao: [],
    Avarias: [],
    SemIncidenciaChecked: false,
    avariaOEALocalChecked: [],
    avariaOEATipoChecked: [],
    avariaOEARemoverChecked: []
}

export default function avariasOEAReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesAvariasOEA.AVARIAS_OEA:
            return {
                ...state,
                $id: action.payload.$id,
                Sucesso: action.payload.Sucesso,
                Mensagem: action.payload.Mensagem,
                TiposAvaria: action.payload.TiposAvaria,
                LocaisAvaria: action.payload.LocaisAvaria,
                TiposAvariaPadrao: action.payload.TiposAvariaPadrao,
                Avarias: action.payload.Avarias
            };
        case TypesAvariasOEA.ADD_AVARIAS_OEA:
            return {
                ...state,
                // Avarias: [...state.Avarias, ...action.payload]
                Avarias: action.payload
            };
        case TypesAvariasOEA.AVARIA_OEA_LOCAL_CHECKED:
            return {
                ...state,
                avariaOEALocalChecked: action.payload
            };
        case TypesAvariasOEA.AVARIA_OEA_TIPO_CHECKED:
            return {
                ...state,
                avariaOEATipoChecked: action.payload
            };
        case TypesAvariasOEA.AVARIA_OEA_REMOVER_CHECKED:
            return {
                ...state,
                avariaOEARemoverChecked: action.payload
            };
        case TypesAvariasOEA.REMOVE_AVARIAS_OEA:
            return ({
                ...state,
                Avarias: [...state.Avarias.filter(function (a) { return !action.payload.includes(a.AvariaDescricao) })]
            })
        case TypesAvariasOEA.SEM_INCIDENCIA_CHECKED:
            return {
                ...state,
                SemIncidenciaChecked: action.payload.SemIncidenciaChecked,
            };
        case TypesAvariasOEA.RESET_OEA:
            return INITIAL;

        default:
            return state;
    }
}

export const AvariasOEAActions = {
    getAvariasOEA,
    addAvariasOEA,
    deletarAvariasOEA,
    resetState,
    alterarSemIncidenciaChecked,
    avariaOEALocalChecked,
    avariaOEATipoChecked,
    avariaOEARemoverChecked
}

function getAvariasOEA(dadosAvarias) {
    return {
        type: TypesAvariasOEA.AVARIAS_OEA,
        payload: dadosAvarias
    }
}

function avariaOEALocalChecked(checked) {
    return {
        type: TypesAvariasOEA.AVARIA_OEA_LOCAL_CHECKED,
        payload: checked
    }
}

function avariaOEATipoChecked(checked) {
    return {
        type: TypesAvariasOEA.AVARIA_OEA_TIPO_CHECKED,
        payload: checked
    }
}

function avariaOEARemoverChecked(checked) {
    return {
        type: TypesAvariasOEA.AVARIA_OEA_REMOVER_CHECKED,
        payload: checked
    }
}

function addAvariasOEA(dadosAvarias) {
    return {
        type: TypesAvariasOEA.ADD_AVARIAS_OEA,
        payload: dadosAvarias
    }
}

function deletarAvariasOEA(avariaOEA) {

    let avariasOEADescricaoRemover = [];

    avariaOEA.forEach(element => {
        avariasOEADescricaoRemover.push(element[0]);
    });

    return {
        type: TypesAvariasOEA.REMOVE_AVARIAS_OEA,
        payload: avariasOEADescricaoRemover
    }
}

function alterarSemIncidenciaChecked(value) {
    return {
        type: TypesAvariasOEA.SEM_INCIDENCIA_CHECKED,
        payload: { SemIncidenciaChecked: value }
    }
}

function resetState() {
    return { type: "RESET_OEA" }
}